<template>
  <main class="layer-popup-container">
    <div class="layer-popup" id="layerPopupFestival">
      <div>
        <div class="popup-wrapper">
          <header class="popup-header">
            <button type="button" class="btn-close" @click="closeModal">
              <i class="icon-close">팝업닫기</i>
            </button>
          </header>
          <div class="popup-body" data-fill="true">
            <div class="popup-festival">
              <div class="popup-festival-content">
                <div class="popup-festival-img">
                  <img :src="eventData.imgFileUrl" alt="" />
                </div>
                <div class="popup-festival-info">
                  <div class="event-Area">{{ eventData.arNm }}</div>
                  <div class="event-name">{{ eventData.arEventNm }}</div>
                  <div class="event-cont">{{ eventData.eventIntro }}</div>
                  <div class="event-date" v-html="eventData.date"></div>
                  <!-- item.salesUnit 데이터 필요 -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'FestivalModal',
  props: {
    eventData: {
      type: Object,
      default: null,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close'); // 부모 컴포넌트로 'close' 이벤트를 발생시켜 모달을 닫도록 요청
    },
  },
};
</script>

<style>
#layerPopupFestival .popup-festival-img img {
  width: auto;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
/* #layerPopupProducts {max-width: 900px; max-height: 680px; background-color: #ffffff; padding: 0 40px 40px 40px;}
#layerPopupProducts .popup-body.popup-festival-body {margin-top:40px}
.popup-festival-img {overflow:hidden; position:relative; margin-bottom:20px; width:100%; height:430px;}
.popup-festival-img img {position:absolute; top:50%; left:50%; width:100%; height:100%; object-fit:cover; transform:translate(-50%, -50%)}
.popup-festival-info {min-height:130px; max-height:130px}
.popup-festival-info__desc .group .row {display:flex; flex-wrap:nowrap}
.popup-festival-info__desc .group .row > * {text-align:left;}
.popup-festival-info__desc .group .row + .row {margin-top:16px}
.popup-festival-info__desc .group .row label {width:100px; font-weight:700}
.popup-festival-info__desc .group .row div {width:calc(100% - 100px); word-break:break-all}
@media screen and (max-width: 800px){
  #layerPopupProducts .popup-body.popup-festival-body {margin-top:0; max-height:100%}
} */
/* @media screen and (max-width: 800px) {
  .popup-product-info__desc .group .row {
    align-items: flex-start;
  }
  .popup-product-info__desc .group label{
    font-size:16px;
  }
}


@media screen and (max-width: 800px) {
  .popup-product-info__desc .group label + div{
    font-size:17px;
  }
} */
</style>